import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ocp-table-empty-row',
  imports: [TranslatePipe],
  host: { style: 'display: contents' },
  template: `
    <tr>
      <td [attr.colspan]="colspan()" class="table-empty-row">
        <ng-content>{{ 'common.no-data' | translate }}</ng-content>
      </td>
    </tr>
  `,
  styles: `
    .table-empty-row {
      text-align: center;
      padding: 2rem;
      opacity: 0.6;
    }
  `,
})
export class TableEmptyRowComponent {
  readonly colspan = input('6');
}
